import * as yaml from "js-yaml";

export const jsonToYaml = (jsonData: string | Record<string, string>): string => {
  const data = typeof jsonData === "string" ? JSON.parse(jsonData) : jsonData;
  return yaml.dump(data, { indent: 2, lineWidth: -1 });
};

export const validateYaml = (yamlString: string): { isValid: boolean; error?: string } => {
  if (!yamlString?.trim()) return { isValid: true };

  try {
    yaml.load(yamlString);
    return { isValid: true };
  } catch (error) {
    return {
      isValid: false,
      error: error instanceof Error ? error.message : "Invalid YAML"
    };
  }
};
